export default "__VITE_ASSET__Cwz6gko7__"